import { liteClient as algoliasearch } from 'algoliasearch/lite'

export const MIN_ALGOLIA_QUERY_LENGTH = 3
export const SEARCH_DEBOUNCE_MS = 300

export const mainIndex = process.env.GATSBY_ALGOLIA_MAIN_INDEX ?? ''
export const querySuggestionsIndex =
  process.env.GATSBY_ALGOLIA_QUERY_SUGGESTIONS_INDEX ?? ''
export const seasonalTrendsIndex =
  process.env.GATSBY_ALGOLIA_SEASONAL_TRENDS_INDEX ?? ''
export const promotionsIndex = process.env.GATSBY_ALGOLIA_PROMOTIONS_INDEX ?? ''

// Indici che Autocomplete InstantSearch proverebbe a cercare: li stubbiamo
// perché i dati typing arrivano da fetchTypingMultiquery
const typingIndices = new Set(
  [mainIndex, querySuggestionsIndex].filter(Boolean)
)

const isTypingIndex = (indexName?: string) => typingIndices.has(indexName ?? '')

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID ?? '',
  process.env.GATSBY_ALGOLIA_API_KEY ?? ''
)

export const directSearchClient = algoliaClient

type SearchParams = Parameters<typeof algoliaClient.search>[0]
type SearchRequest = {
  indexName?: string
  query?: string
  params?: string | { query?: string }
}

const readQuery = ({ query, params }: SearchRequest) => {
  if (typeof query === 'string') return query.trim()

  if (typeof params === 'string') {
    return (new URLSearchParams(params).get('query') ?? '').trim()
  }

  return (params?.query ?? '').trim()
}

const emptyResult = (query: string) => ({
  hits: [],
  nbHits: 0,
  page: 0,
  nbPages: 0,
  hitsPerPage: 0,
  processingTimeMS: 0,
  exhaustiveNbHits: false,
  query,
  params: '',
})

// InstantSearch Autocomplete: stub sempre main+QS; dati typing da fetchTypingMultiquery
export const searchClient = {
  ...algoliaClient,
  async search(params: SearchParams) {
    const requests = (
      Array.isArray(params) ? params : params.requests
    ) as SearchRequest[]
    const skipped = requests.map((request) => isTypingIndex(request.indexName))

    if (!skipped.some(Boolean)) return algoliaClient.search(params)

    if (skipped.every(Boolean)) {
      return {
        results: requests.map((request) => emptyResult(readQuery(request))),
      }
    }

    const response = await algoliaClient.search({
      requests: requests.filter((_, index) => !skipped[index]),
    } as SearchParams)
    let next = 0

    return {
      ...response,
      results: skipped.map((isSkipped, index) =>
        isSkipped
          ? emptyResult(readQuery(requests[index]!))
          : response.results[next++]!
      ),
    }
  },
} as typeof algoliaClient
